// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'snabbdom-jsx-lite';
import { BannerEl } from 'common/components/banner';
import { ActionEvent, BannerAction, BannerSize, BannerType } from 'common/components/banner/types';
import { Store } from 'common/report/stores/store';
import { SavedReportsLimit } from 'common/report/stores/saved-reports-limit';
import { trackUpsellEvent } from 'common/report/util/tracking-helpers';
import { prompt } from 'common/components/confirm';
import { THEME } from 'common/components/confirm/types';
import { savedReportLimitInfo, savedReportsLimitStore } from 'common/report/stores/saved-reports-limit';
import { LocalizationStore } from 'common/i18n/store';
const PRICING_HREF = "/pricing/?utm_source=number_reports_gate";
export function savedReportsLimitBannerRenderer(store: Store<Record<string, SavedReportsLimit>>, projectId: number, i18n: LocalizationStore) {
  var _store$value$projectI;
  let bannerClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  const savedReportsLimit: SavedReportsLimit = (_store$value$projectI = store.value[projectId]) !== null && _store$value$projectI !== void 0 ? _store$value$projectI : {
    hasFiniteLimit: false,
    isBelowLimit: false
  };
  if (savedReportsLimit.hasFiniteLimit) {
    const bannerSel = bannerClass ? ".".concat(bannerClass) : "";
    return <BannerEl sel={bannerSel} attrs={{
      theme: savedReportsLimit.isBelowLimit ? "info" : "warn",
      type: BannerType.Embedded,
      size: BannerSize.Medium,
      'header-text': i18n.t("components.create-entity.report-limit-title", {
        count: savedReportsLimit.savedReportsCount,
        limit: savedReportsLimit.finiteLimit
      }),
      'body-text': i18n.t("components.create-entity.report-limit-description", {
        limit: savedReportsLimit.finiteLimit
      }),
      ctas: [{
        actionName: BannerAction.Upgrade,
        text: i18n.t("common.upgrade"),
        icon: "share",
        href: PRICING_HREF
      }],
      'style-override': ".banner-wrapper .banner-panel .banner-copy {width: calc(100% - 130px)}",
      'banner-tracking-type': "Saved Reports Limit"
    }} on={{
      action: (ev: ActionEvent) => {
        if (ev.detail.actionName === BannerAction.Upgrade) {
          trackUpsellEvent("Click Upsell", "bookmark");
        }
      }
    }} />;
  }
  return null;
}
export function canSaveNewReports(store: Store<Record<string, SavedReportsLimit>>, projectId: number): boolean {
  var _store$value$projectI2, _store$value$projectI3;
  return (_store$value$projectI2 = (_store$value$projectI3 = store.value[projectId]) === null || _store$value$projectI3 === void 0 ? void 0 : _store$value$projectI3.isBelowLimit) !== null && _store$value$projectI2 !== void 0 ? _store$value$projectI2 : false;
}
export async function promptSaveReportLimitModal(projectId, i18n: LocalizationStore) {
  let newReport = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const {
    isBelowLimit
  } = savedReportLimitInfo(projectId);
  const canSaveReport = isBelowLimit || !newReport;
  const promptResponse = await prompt({
    closeable: false,
    'confirm-button-label': canSaveReport ? "Save Report" : "Upgrade",
    open: true,
    theme: canSaveReport ? THEME.INFO : THEME.WARN,
    title: canSaveReport ? "Save Report" : "Saved Report Limit Reached"
  }, {
    bannerContent: savedReportsLimitBannerRenderer(savedReportsLimitStore, projectId, i18n, "banner")
  });
  const {
    didConfirm
  } = promptResponse;
  if (didConfirm && !canSaveReport) {
    window.open(PRICING_HREF);
  }
}